import * as React from "react";
const SvgType01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.965 7c0-.48 0-.788-.017-1.023-.015-.226-.041-.31-.056-.346a.97.97 0 0 0-.523-.523c-.037-.015-.12-.04-.346-.056A17 17 0 0 0 17 5.035h-3.965v13.93H15a1.035 1.035 0 0 1 0 2.07H9a1.035 1.035 0 0 1 0-2.07h1.965V5.035H7c-.48 0-.788 0-1.023.017-.226.015-.31.041-.346.056a.97.97 0 0 0-.523.523c-.015.037-.04.12-.056.346-.016.235-.017.543-.017 1.023a1.035 1.035 0 0 1-2.07 0c0-.452 0-.843.021-1.165.023-.332.073-.665.21-.996A3.04 3.04 0 0 1 4.84 3.196c.33-.137.664-.187.996-.21.322-.022.713-.021 1.165-.021h10c.452 0 .843 0 1.165.021.332.023.665.073.996.21a3.04 3.04 0 0 1 1.643 1.643c.137.33.187.664.21.996.022.322.021.713.021 1.165a1.035 1.035 0 0 1-2.07 0"
}));
export default SvgType01;
//# sourceMappingURL=Type01.js.map